var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("关于页面")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }